<template>
<div>
    <PurchaseOrderDetailList/>
</div>
</template>

<script>
import PurchaseOrderDetailList from '@/components/menuadmin/stock/stocklist/PurchaseOrderDetailList.vue'
export default {
    name: 'purchaseOrderDetail',
     components:{
        PurchaseOrderDetailList,
    },
}
</script>


